import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ExportAllNotificationCardModel } from './export-all-notification-card.model';
import { JobNotificationCardComponent } from '../job-notification-card.component';
import { PrintActionButtonsComponent } from '../../../action-buttons/print-action-buttons/print-action-buttons.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-export-all-notification-card',
  styleUrls: ['./export-all-notification-card.component.scss'],
  templateUrl: './export-all-notification-card.component.html',
  imports: [JobNotificationCardComponent, PrintActionButtonsComponent],
})
export class ExportAllNotificationCardComponent {
  @Output() public closeEvent = new EventEmitter<void>();
  @Output() public downloadAllButtonEvent = new EventEmitter<void>();
  @Input() public exportAllNotificationCard: ExportAllNotificationCardModel;

  public downloadAllButtonClickedHandler(): void {
    this.downloadAllButtonEvent.emit();
  }

  public onCloseClickedHandler(): void {
    this.closeEvent.emit();
  }
}
